import {Injectable} from '@angular/core';
import {TableWsService} from "../../websocket/table-ws.service";
import {WebsocketService} from "../../websocket/websocket.service";

@Injectable({
  providedIn: 'root'
})
export class ClearingOrderWsService extends TableWsService {

  constructor(websocketService: WebsocketService) {
    super(websocketService, 'order');
  }

}
